<div class="returnOrder">
    <div class="title" *ngIf="!addRelease">
        <div class="t1">
            <span> Return Reference</span>
            <span class="desc">Create/Upload your Return Reference here</span>
        </div>
        <div class="t2">
            <mat-checkbox color="primary" [(ngModel)]="showCancelled"> Include inactive Return Orders</mat-checkbox>
            <!-- <span *ngFor="let item of requestService.selectedRequest?.requirement"> // not to add back as it can be seen on request details on same frame
                {{item?.quantity}}*{{item?.container_size_type?.display}} ({{item?.condition?.value}})
            </span> -->
            <!-- <mat-chip color="primary" selected> Pending For RO Generation: {{returnOrder?.pending_return_quantity
                }}</mat-chip> -->
            <logzy-chipper [label]="' Pending For RO Generation: '"
                           [value]="returnOrder?.pending_return_quantity"></logzy-chipper>
            <div>
                <mat-chip class="primary-chip sleek-chip" (click)="generateDropOffSchedule()" style="cursor: pointer;"
                          *ngIf="showDownloadSchedule">View Drop-off
                    Schedule
                </mat-chip>
            </div>
        </div>
    </div>
    <div class="returnOrderList empty" *ngIf="!addRelease && emptyList">
        <logzy-billu *ngIf="isCustomer && transactionType!='supply'" part1="No " part2="record " part3="found."
                     font="12px"></logzy-billu>
        <logzy-billu *ngIf="isCustomer && transactionType=='supply'" part1="Create " part2="Return " part3="Reference"
                     font="12px" [button]="true" (action1)="addRelease = true"></logzy-billu>
        <logzy-billu *ngIf="!isCustomer" part1="Create " part2="Return " part3="Reference" font="12px" [button]="true"
                     (action1)="addRelease = true"></logzy-billu>
    </div>
    <ng-container *ngIf="!emptyList">
        <logzy-coupon *ngIf="loading"></logzy-coupon>
        <logzy-coupon *ngIf="loading"></logzy-coupon>
        <ng-container *ngFor="let item of returnOrder?.return_list">
            <div *ngIf="!(item.status=='Cancelled' && (!showCancelled))" class="releaseOrderList"
                 [class.canceled]="item.status == 'Cancelled'" fxLayout="column">
                <div fxLayout="row" fxFlex="100" class="justify-content-between ">
                    <img class="cancelledWatermark" src="/assets/images/icons/cancelled.svg" alt=""
                         *ngIf="item.status=='Cancelled'">
                    <div fxLayout="row" fxFlex="100" class="justify-content-between ">

                        <div class="ROdetails">
                            <span class="dtitle">Return Reference:</span><span>{{ item.return_reference_no }}</span>
                        </div>
                        <div class="status">
                            <mat-chip>{{ item.requirement.container_size_type.display }}</mat-chip>
                            <mat-chip *ngIf="isShownOptions">{{ item.do_owner?.value }}</mat-chip>
                            <!-- <mat-chip>{{item.status}}</mat-chip> -->
                            <mat-chip>Pending For Drop-off: {{
                                    item.remaining_dropoff_quantity == null ?
                                        "0" : item.remaining_dropoff_quantity
                                }}/{{ item.quantity }}
                            </mat-chip>
                            <i class="flaticon-close" matTooltip="Cancel Return Reference"
                               *ngIf="item.drop_off_quantity <= 0 && isShownOptions" (click)="CancelOrder(item)"></i>
                        </div>

                    </div>
                </div>
                <div fxLayout="row" fxFlex="100" class="ROdetailSet ">
                    <div fxLayout="column" fxFlex="65">
                        <div class="ROdetails">
                            <span class="dtitle" fxFlex="9em">Validity Date:</span><span fxFlex="70">{{
                                item.valid_till |
                                    date:"dd MMM, yyyy"
                            }}</span>
                        </div>
                        <div class="ROdetails">
                            <span class="dtitle" fxFlex="9em">Depot:</span><span
                            fxFlex="70">{{ item.depot?.display_name }},{{ item?.address }}</span>
                        </div>
                        <div class="ROdetails">
                            <span class="dtitle" fxFlex="9em">Contact Person:</span><span fxFlex="70">
                                {{ item?.depot_contact_full_name }}
                            </span>
                            <span class="dtitle" fxFlex="9em">Contact Number:</span><span fxFlex="70">
                                {{ item?.depot_contact_number }}
                            </span>
                            <span class="dtitle" fxFlex="9em">Contact Email:</span><span fxFlex="70">
                                {{ item?.depot_contact_email }}
                            </span>
                        </div>
                        <div class="ROdetails" *ngIf="item.supply_rr != null && isShownOptions">
                            <span class="dtitle" fxFlex="9em">Supplier DO Details</span>
                            <div>
                                <div fxFlex="100" fxLayout="column" class="sddData">
                                    <span>
                                        <b>Req No:</b> {{ item.supply_rr?.request.request_number }} (<b>RO:</b> {{
                                            item.supply_rr?.return_reference_no
                                        }})
                                    </span>
                                    <span>
                                        {{
                                            item.supply_rr?.request.external_reference_no != null ?
                                                item.supply_rr?.request.external_reference_no + '(' +
                                                item.supply_rr?.request.request_source + ')' : '-' +
                                                '(' + item.supply_rr?.request.request_source + ')'
                                        }}
                                    </span>
                                    <!-- <span>Qty Avl for RO Creation. {{ item.supply_rr?.available_for_supply_quantity }}
                                    </span> -->
                                    <!-- <span class="email">
                                        Rem Pick-up Qty. {{ item.supply_rr.remaining_pickup_quantity }}
                                    </span> -->
                                </div>
                            </div>
                            <div>
                                <a (click)="loadDO(item)" target="_blank"><i class="flaticon-open-tab" style="font-size: 15px;
                                        line-height: 1.6;" matTooltip="View DO Details"></i></a>
                            </div>
                        </div>
                        <!-- <div class="ROdetails">
                            <span class="dtitle" fxFlex="25">Contact person:</span>
                            <div class="contact" fxFlex="70" *ngFor="let contact of item?.return_contact_information">
                                <span>{{contact?.name}}</span>
                                <span>{{contact?.email}}</span>
                                <span>{{contact?.contact_no}}</span>
                            </div>
                        </div> -->
                        <ng-container *ngIf="isHide">
                            <div class="revalidate" *ngIf="item?.external_return_revalidation_request?.length>0">
                                <span>Revalidation Requested by
                                    {{ item?.external_return_revalidation_request[0]?.created_by?.first_name }}
                                    {{ item?.external_return_revalidation_request[0]?.created_by?.last_name }}</span>
                                <span class="fs-12"> Created at
                                    {{
                                        item?.external_return_revalidation_request[0]?.created_at
                                            |
                                            date
                                    }}</span>
                                <div class="action">
                                    <button mat-stroked-button class="Cancel sleekBtn"
                                            (click)="denyRequest(item)">Deny
                                    </button>
                                    <button mat-stroked-button class="Save sleekBtn"
                                            (click)="ReValidateOrder(item)">Approve
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="qrCode" fxFlex="9">
                        <logzy-img-loader [src]="item.return_qr_url" border_radius="5px"></logzy-img-loader>
                    </div>
                </div>
                <div fxLayout="row" class="actionRow">
                    <div class="stat-pick">
                        <!-- <mat-chip color="primary" (click)="navigateDtopoff()">+ Mark Return</mat-chip> -->
                        <mat-chip *ngIf="!isCustomer" class="primary-chip sleek-chip" (click)="navigateDtopoff()">{{
                                transactionType == 'supply' ? 'View drop-off' : 'Mark drop-off'
                            }}
                        </mat-chip>
                        <mat-chip *ngIf="isCustomer" class="primary-chip sleek-chip" (click)="navigateDtopoff()">View
                            drop-off
                        </mat-chip>

                        <!-- <button mat-stroked-button (click)="navigateDtopoff()">Mark drop-off</button> -->
                        <mat-chip *ngIf="isShownOptions" class="secondary-chip sleek-chip"
                                  (click)="ReValidateOrder(item)">Revalidate
                        </mat-chip>
                        <!-- <button mat-stroked-button (click)="ReValidateOrder(item)">Revalidate</button> -->
                        <!-- <mat-chip *ngIf="isCustomer" class="secondary-chip sleek-chip"
                            (click)="ReValidateCustOrder(item)">Return Order
                            Extend
                            Request</mat-chip> -->
                        <!-- <button *ngIf="isCustomer" mat-stroked-button (click)="ReValidateCustOrder(item)">Return Order
                            Extend
                            Request</button> -->
                        <!-- <mat-chip *ngIf="isShow" color="primary" selected (click)="ReValidateOrder(item)">+
                        Revalidate</mat-chip> -->

                    </div>
                    <div class="actionListIcon">
                        <!-- <i class="flaticon-delete" matTooltip="Cancel Release Order" (click)="CancelOrder(item)"></i> -->
                        <a [href]="item.return_url" target="_blank" [download]="item.return_reference_no + '.pdf'"><i
                            class="flaticon-download"></i></a>
                        <i *ngIf="isShownOptions" class="flaticon-pencil-tool" matTooltip="Edit Return Reference"
                           (click)="EditOrder(item,item.do_contacts_information)"></i>
                        <i class="flaticon-share-details" matTooltip="Share Return Order on mail"
                           (click)="openSendConfirmationDialog(item, 'Return Order shared on email', 'returnOrder')"></i>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="(addRelease || !emptyList) && transactionType == 'supply'">
        <hr *ngIf="!emptyList">
        <div class="title">
            <div class="t1">
                <span>Create new Return Reference</span>
                <span class="desc">Create/Upload your Return Reference here</span>
            </div>
        </div>
        <div class="inputs" fxLayout="row wrap">
            <ng-container>
                <app-mat-auto-search [isEditable]="true" [label]="'Requirement*'"
                                     [displayField]="'container_size_type.display'" [name]="'requirement'"
                                     [searchable]="false"
                                     [(ngModel)]="returnConObject.requirement"
                                     (ngModelChange)="onRequirementChange($event)"
                                     [idField]="null" [options]="requestService.requirementList" [labelItemTemplate]="reqSelectedItem"
                                     [itemTemplate]="reqItem" fxFlex="12em" fxLayout="column"
                                     [errors]="errorObj.requirement"
                                     [tooltipIcon]="true" [tooltipName]="'Requirement List'">
                </app-mat-auto-search>
            </ng-container>
            <app-text-field [isMultiline]="false" [isEditable]="false" [label]="'DO Owner*'" fxFlex="12em"
                            fxLayout="column" [(ngModel)]="DOOwnerdata.description" [required]="addressRequired"
                            [name]="'do_owner'">
            </app-text-field>
            <app-mat-auto-search [isEditable]="true" [label]="'Drop-off Depot*'" [displayField]="'name_display'"
                                 [name]="'name'" [(ngModel)]="returnConObject.depot"
                                 (ngModelChange)="selectedDepot($event)"
                                 [idField]="null" [listUrl]="dropOffLocationListUrl1" [setSearchValue]="this.isShown"
                                 *ngIf="returnConObject.requirement" [labelItemTemplate]="depotSelectedItem"
                                 [itemTemplate]="depotItem"
                                 fxFlex="12em" fxLayout="column" [errors]="errorObj.depot">
            </app-mat-auto-search>

            <ng-container *ngIf="showDepotDetailsSection">
                <div fxFlex="12em" fxLayout="column" class="addbox" [class.d-none]="!depotSeleted">
                    <span class="inputTitle">Address of Depot</span>
                    <div class="address">
                        <span class="depotAddress">
                            {{ depotAddress }}
                        </span>
                        <!-- <span class="viewAddress">View on Map</span> -->
                    </div>
                </div>

                <!-- <app-mat-auto-search [isEditable]="true" [label]="'Contact Detail'"
                    [displayField]="'phone.as_international'" [name]="'contact_no'"
                    [(ngModel)]="returnContactObject.contact_no" [idField]="null" [options]="depotContacts"
                    [labelItemTemplate]="contactSelectedItem" [itemTemplate]="contactItem" fxFlex="12em"
                    fxLayout="column" [class.d-none]="hasPropertyIsInternational"
                    (ngModelChange)="selectedAddress($event)" [setSearchValue]="this.isShown"
                    *ngIf="depotContacts.length != 0">
                </app-mat-auto-search> -->

                <ng-container>
                    <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Depot Contact Person'"
                                    fxFlex="12em"
                                    fxLayout="column" [(ngModel)]="returnConObject.depot_contact_full_name"
                                    [required]="addressRequired" [name]="'description'"
                                    [errors]="errorObj.depot_contact_full_name">
                    </app-text-field>

                    <!-- <app-phone-field [isEditable]="true" [label]="'Contact Person Mobile'"
                        [(ngModel)]="releaseObject.depot_contact_number" [name]="'mobile_number'"
                        [errors]="errorObj.depot_contact_number" [removeCross]="true" fxFlex="12em"
                        fxLayout="column">
                    </app-phone-field> -->

                    <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Contact Number'" fxFlex="12em"
                                    fxLayout="column" [(ngModel)]="returnConObject.depot_contact_number"
                                    [name]="'mobile_number'"
                                    [errors]="errorObj.depot_contact_number">
                    </app-text-field>

                    <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Contact Email'" fxFlex="12em"
                                    [required]="addressRequired" fxLayout="column"
                                    [(ngModel)]="returnConObject.depot_contact_email"
                                    [name]="'description'" [errors]="errorObj.depot_contact_email">
                    </app-text-field>
                </ng-container>
            </ng-container>

            <logzy-money-field [isEditable]="true" [label]="'Drop-off Charge*'"
                               [(amount)]="returnConObject.storage_charge"
                               [(currencyCode)]="returnConObject.storage_charge_currency"
                               fxFlex="12em" fxLayout="column" [class.d-none]="!depotSeleted" [minValue]="0"
                               [maxlength]="9"
                               [errors]="errorObj.storage_charge">
            </logzy-money-field>

            <!-- <app-number-field [isEditable]="true" [containerNum]="true" [minValue]="1" [label]="'Drop-off Quantity*'"
                fxFlex="12em" fxLayout="column" [(ngModel)]="returnConObject.quantity" [errors]="errorObj.quantity">
            </app-number-field> -->

            <app-date-field [isEditable]="true" [label]="'Valid From*'" [(ngModel)]="returnConObject.billed_from"
                            (ngModelChange)="dateChange($event)" [errors]="errorObj.billed_from" fxFlex="12em"
                            fxLayout="column"></app-date-field>

            <app-date-field [isEditable]="true" [label]="'Validity Date*'" [(ngModel)]="returnConObject.valid_till"
                            [errors]="errorObj.valid_till" [minDate]="returnConObject.billed_from" fxFlex="12em"
                            fxLayout="column"></app-date-field>

            <app-text-field *ngIf="isShown" [isEditable]="true" [label]="'Return Reference No*'"
                            [(ngModel)]="returnConObject.return_reference_no" [name]="'description'" class=""
                            fxFlex="12em"
                            fxLayout="column" [errors]="errorObj.return_reference_no">
            </app-text-field>
            <app-text-field [isMultiline]="true" [errors]="errorObj.handling_remarks" [isEditable]="true"
                            [label]="'Additional handling info'" fxFlex="12em" fxLayout="column" [name]="'description'"
                            [(ngModel)]="returnConObject.handling_remarks" class="">
            </app-text-field>

            <div fxLayout="column" class="addbox" *ngIf="isShown">
                <span class="inputTitle">Supplier return reference document*</span>
                <app-file-field [isEditable]="true" [(ngModel)]="returnConObject.upload_document" [multiple]="false"
                                [documentTypeDevName]="'do_doc'" [showUploadedList]="false" [name]="'upload_document'"
                                fxLayout="row wrap" [errors]="errorObj.upload_document">
                </app-file-field>
                <div class="uploadedDoc" *ngIf="returnConObject?.upload_document">
                    <span>Uploaded file:</span>
                    <span
                        class="name">{{ returnConObject?.upload_document?.original_filename }}
                        .{{ returnConObject?.upload_document?.extension }}
                    </span>
                    <span class="size">
                        {{ embassyService.readableFileSize(returnConObject?.upload_document?.size) }}</span>
                </div>
            </div>
            <!-- <div style="width: 50%;"> -->
            <logzy-containerslistforpickup [request_id]="request_id" [containerSizeTypeId]="containerSizeTypeId"
                                           fxFlex="40em" [type]="'supply'"
                                           *ngIf="showContainers"></logzy-containerslistforpickup>
            <!-- </div> -->

        </div>
        <button class="loadingBtn sleekBtn Save" mat-raised-button
                [disabled]="disableSaveButton || (transactionType == 'supply' && returnConObject?.upload_document == null)"
                (click)="saveOrder()">
            <span *ngIf="!disableSaveButton">Save Return Reference</span>
            <div *ngIf="disableSaveButton" class="p03">
                <i class="flaticon-loading spin"></i>
                <span>Saving...</span>
            </div>
        </button>
        <!-- <button mat-raised-button class="Save" [disabled]="isDisabled" (click)="saveOrder()">Save Return
            Reference</button> -->
    </ng-container>
    <ng-container *ngIf="!isCustomer">
        <ng-container *ngIf="(addRelease || !emptyList) && transactionType == 'use'">
            <hr *ngIf="!emptyList">
            <div class="title">
                <div class="t1">
                    <span>Create new Return Reference</span>
                    <span class="desc">Create/Upload your Return Reference here</span>
                </div>
            </div>
            <div class="inputs" fxLayout="row wrap">
                <ng-container>
                    <app-mat-auto-search [isEditable]="true" [label]="'Requirement*'"
                                         [displayField]="'container_size_type.display'" [name]="'requirement'"
                                         [searchable]="false"
                                         [(ngModel)]="returnConObject.requirement"
                                         (ngModelChange)="onRequirementChangeUse($event)"
                                         [idField]="null" [options]="requestService.requirementList"
                                         [labelItemTemplate]="reqSelectedItem"
                                         [itemTemplate]="reqItem" fxFlex="12em" fxLayout="column"
                                         [errors]="errorObj.requirement"
                                         [tooltipIcon]="true" [tooltipName]="'Requirement List'">
                    </app-mat-auto-search>
                </ng-container>
                <app-toggle-select class="inputToggle" [isEditable]="true" [label]="'RO Owner*'"
                                   [(ngModel)]="returnConObject.do_owner" (ngModelChange)="changeDOowner($event)"
                                   [name]="'do_owner'"
                                   [displayField]="'value'" [options]="DOOwnerdata" fxFlex="12em" fxLayout="column"
                                   *ngIf="returnConObject.requirement" [errors]="errorObj.do_owner">
                </app-toggle-select>

                <ng-container *ngIf="(requestType == 'one_way' || requestType == 'lease') && dev_value == 'supplier'">
                    <app-mat-auto-search [isEditable]="true" [label]="'Supplier*'" [displayField]="'request_number'"
                                         [name]="'supplier'" [(ngModel)]="returnConObject.supplier" [idField]="null"
                                         [listUrl]="supplierListUrl" [labelItemTemplate]="supplierSelectedItem"
                                         [itemTemplate]="supplierItem" (ngModelChange)="filterSupplierDO($event)"
                                         fxFlex="12em"
                                         fxLayout="column" [tooltipIcon]="true"
                                         [tooltipName]="'You can search by the supplier name'"
                                         [errors]="errorObj.booking_no" *ngIf="returnConObject.do_owner">
                    </app-mat-auto-search>

                    <app-mat-auto-search [isEditable]="true" [label]="'Supplier Return Ref.*'"
                                         [displayField]="'request.request_number'" [name]="'address'"
                                         [(ngModel)]="returnConObject.supply_rr" [idField]="null"
                                         [listUrl]="supplierDOListUrl"
                                         [labelItemTemplate]="doSelectedItem" [itemTemplate]="doItem" fxFlex="12em"
                                         fxLayout="column"
                                         [errors]="errorObj.supply_rr" *ngIf="returnConObject.supplier"
                                         (ngModelChange)="loadSupplierAddress($event)" [tooltipIcon]="true"
                                         [tooltipName]="'You can search by DO reference number, external reference number or request number'">
                    </app-mat-auto-search>
                </ng-container>

                <app-mat-auto-search [isEditable]="true" [label]="'Drop-off Depot*'" [displayField]="'name_display'"
                                     [name]="'name'" [(ngModel)]="returnConObject.depot"
                                     (ngModelChange)="selectedDepot($event)"
                                     [idField]="null" [listUrl]="dropOffLocationListUrl1"
                                     [setSearchValue]="this.isShown"
                                     [labelItemTemplate]="depotSelectedItem" [itemTemplate]="depotItem" fxFlex="12em"
                                     fxLayout="column"
                                     [errors]="errorObj.depot" [disabled]="dev_value == 'supplier'">
                </app-mat-auto-search>
                <div fxFlex="12em" fxLayout="column" class="addbox" [class.d-none]="!depotSeleted">
                    <span class="inputTitle">Address of Depot</span>
                    <div class="address">
                        <span>
                            {{ depotAddress }}
                        </span>
                        <!-- <span class="viewAddress">View on Map</span> -->
                    </div>
                </div>

                <ng-container *ngIf="showDepotDetailsSection">
                    <!-- <app-mat-auto-search [isEditable]="true" [label]="'Contact Detail'"
                    [displayField]="'phone.as_international'" [name]="'contact_no'"
                    [(ngModel)]="returnConObject.contact_no" [idField]="null" [options]="depotContacts"
                    [labelItemTemplate]="contactSelectedItem" [itemTemplate]="contactItem" fxFlex="12em"
                    fxLayout="column" [class.d-none]="hasPropertyIsInternational"
                    *ngIf="dev_value != 'supplier' && (depotContacts? depotContacts.length != 0 : true)"
                    (ngModelChange)="selectedAddress($event)" [setSearchValue]="true">
                </app-mat-auto-search> -->

                    <ng-container>
                        <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Depot Contact Person'"
                                        fxFlex="12em"
                                        fxLayout="column" [(ngModel)]="returnConObject.depot_contact_full_name"
                                        [required]="addressRequired" [name]="'description'"
                                        [errors]="errorObj.depot_contact_full_name">
                        </app-text-field>

                        <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Contact Number'"
                                        fxFlex="12em" fxLayout="column"
                                        [(ngModel)]="returnConObject.depot_contact_number"
                                        [name]="'mobile_number'" [errors]="errorObj.depot_contact_number">
                        </app-text-field>

                        <app-text-field [isMultiline]="false" [isEditable]="true" [label]="'Contact Email'"
                                        fxFlex="12em" [required]="addressRequired" fxLayout="column"
                                        [(ngModel)]="returnConObject.depot_contact_email" [name]="'description'"
                                        [errors]="errorObj.depot_contact_email">
                        </app-text-field>
                    </ng-container>
                </ng-container>

                <ng-container>
                    <logzy-money-field [isEditable]="true" [label]="'Drop-off Charge*'"
                                       [(amount)]="returnConObject.storage_charge"
                                       [(currencyCode)]="returnConObject.storage_charge_currency" fxFlex="12em"
                                       fxLayout="column"
                                       [class.d-none]="!depotSeleted" [errors]="errorObj.storage_charge">
                    </logzy-money-field>

                    <!-- <app-number-field [isEditable]="true" [containerNum]="true" [minValue]="1"
                    [label]="'Drop-off Quantity*'" fxFlex="12em" fxLayout="column"
                    [(ngModel)]="returnConObject.quantity" [errors]="errorObj.quantity">
                </app-number-field> -->

                    <app-date-field [isEditable]="true" [label]="'Valid From*'"
                                    [(ngModel)]="returnConObject.billed_from" (ngModelChange)="dateChange($event)"
                                    [errors]="errorObj.billed_from" fxFlex="12em" fxLayout="column"></app-date-field>

                    <app-date-field [isEditable]="true" [label]="'Validity Date*'"
                                    [(ngModel)]="returnConObject.valid_till" [errors]="errorObj.valid_till"
                                    [minDate]="returnConObject.billed_from"
                                    fxFlex="12em" fxLayout="column"></app-date-field>

                    <app-text-field [isMultiline]="true" [errors]="errorObj.handling_remarks" [isEditable]="true"
                                    [label]="'Additional handling info'" fxFlex="12em" fxLayout="column"
                                    [name]="'description'"
                                    [(ngModel)]="returnConObject.handling_remarks" class="">
                    </app-text-field>

                </ng-container>
                <ng-container>
                    <logzy-contact-persons style="min-width: 12em;"></logzy-contact-persons>
                </ng-container>
                <!-- <div class="setTable" style="width: 50%;"> -->
                <logzy-containerslistforpickup [request_id]="request_id" [containerSizeTypeId]="containerSizeTypeId"
                                               [type]="'arcon'" fxFlex="40em" [errorList]="pickupTableErrorList"
                                               *ngIf="showContainers"></logzy-containerslistforpickup>
                <!-- </div> -->

                <ng-container>
                    <app-select-field [isEditable]="true" [name]="'termsCondition'" [displayField]="'name'"
                                      [hidden]="termsConditionList?.length == 1" [(ngModel)]="termsAndCondition"
                                      [options]="termsConditionList" fxLayout="column" fxFlex="12em"
                                      (ngModelChange)="showSelectedTermsAndCondition()">
                    </app-select-field>
                    <quill-editor [styles]="{'min-height': '50px'}" [(ngModel)]="selectedTermsAndCondition"
                                  id="termsAndCondition" [modules]="modules" #editor
                                  placeholder="Enter Terms and Conditions ....." style="width: inherit;">
                    </quill-editor>
                </ng-container>
                <!-- <app-text-field *ngIf="isShown" [isEditable]="true" [label]="'Return Reference No*'"
                [(ngModel)]="returnConObject.return_reference_no" [name]="'description'" class="" fxFlex="12em"
                fxLayout="column" [errors]="errorObj.return_reference_no">
                </app-text-field> -->

                <!-- <div fxLayout="column" class="addbox" *ngIf="isShown">
                <span class="inputTitle">Supplier return reference document*</span>
                <app-file-field [isEditable]="true" [(ngModel)]="returnConObject.upload_document" [multiple]="false"
                    [documentTypeDevName]="'do_doc'" [showUploadedList]="false" [name]="'upload_document'"
                    fxLayout="row wrap" [errors]="errorObj.upload_document">
                </app-file-field>
                <div class="uploadedDoc" *ngIf="returnConObject?.upload_document">
                    <span>Uploaded file:</span>
                    <span
                        class="name">{{returnConObject?.upload_document?.original_filename}}.{{returnConObject?.upload_document?.extension}}
                    </span>
                    <span class="size">
                        {{embassyService.readableFileSize(returnConObject?.upload_document?.size)}}</span>
                </div>
            </div> -->

            </div>
            <button class="loadingBtn sleekBtn Save" mat-raised-button
                    [disabled]="disableSaveButton && termsConditionList.length == 0" (click)="saveOrder()">
                <span *ngIf="!disableSaveButton">Save Return Reference</span>
                <div *ngIf="disableSaveButton" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving...</span>
                </div>
            </button>
            <!-- <button mat-raised-button class="Save" [disabled]="isDisabled" (click)="saveOrder()">Save Return
            Reference</button> -->
        </ng-container>
    </ng-container>
</div>

<ng-template #depotItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.name_display }}
        </span>
        <!-- <span class="email">
            Available Qty :{{ item.container_count }}
        </span> -->
        <span class="email">
            {{ item.address }}
        </span>
    </div>
</ng-template>

<ng-template #depotSelectedItem let-item>
    {{ item.name_display }}
</ng-template>

<!-- //template for Contact -->
<ng-template #contactItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.first_name }} {{ item.last_name }}

        </span>
        <span class="email">
            {{ item.email }}
        </span>
        <span class="email">
            {{ item?.phone?.as_international }}
        </span>
    </div>
</ng-template>

<ng-template #contactSelectedItem let-item>
    <!-- {{item.phone.as_international}} -->
    {{ item.email }}

</ng-template>

<ng-template #bookingItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.request_number }}
        </span>
        <span class="email">
            {{
                item.external_reference_no != null ? item.external_reference_no + '(' + item.request_source + ')' : '-' +
                    '(' + item.request_source + ')'
            }}
        </span>
        <span class="email">
            {{ item.requestor?.company?.legal_name ?? item.requestor?.company?.name }}
        </span>
        <span class="email" *ngFor="let requirement of item.requirement">
            {{ requirement?.quantity + '*' + requirement?.container_size_type?.display }}
        </span>
    </div>
</ng-template>

<ng-template #bookingSelectedItem let-item>
    {{ item.request_number }}
</ng-template>


<ng-template #doItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            <span style="font-weight: bold;">Req No:</span> {{ item.request.request_number }}
        </span>
        <span class="email">
            {{
                item.request.external_reference_no != null ? item.request.external_reference_no + '(' +
                    item.request.request_source + ')' : '-' +
                    '(' + item.request.request_source + ')'
            }}
        </span>
        <span class="email">
            <span style="font-weight: bold;">RO:</span> {{ item.return_reference_no }}
        </span>
        <span class="email">
            Qty Avl for RO Creation. {{ item.available_for_supply_quantity }}
        </span>
        <!-- <span class="email">
            Rem Pick-up Qty. {{ item.remaining_pickup_quantity }}
        </span> -->
    </div>
</ng-template>

<ng-template #doSelectedItem let-item>
    {{ item.request.request_number + '(' + item.return_reference_no + ')' }}
</ng-template>

<ng-template #supplierItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.trade_name }}
        </span>
        <span class="email">
            {{ item.primary_branch.address }}
        </span>
    </div>
</ng-template>

<ng-template #supplierSelectedItem let-item>
    {{ item.trade_name }}
</ng-template>

<ng-template #reqItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.container_size_type?.display }} {{
                item?.condition != null ? '(' + item?.condition?.description + ')' : ''
            }}
        </span>
        <span class="email">
            Qty: {{ item.quantity }}
        </span>
        <span class="email">
            {{ item.system_remarks }}
        </span>
    </div>
</ng-template>

<ng-template #reqSelectedItem let-item>
    {{ item.container_size_type?.display }} {{
        item?.condition != null ? '(' + item?.condition?.description + ')' : ''
    }}
</ng-template>
